import { Backdrop, CircularProgress } from "@mui/material";
import { useAppSelector } from "../redux/store";

const LoadingOverlay = () => {
  const { validatingUser } = useAppSelector((state) => state.login);
  return (
    <Backdrop
      sx={{
        backdropFilter: "blur(10px)",
        zIndex: (theme) => theme.zIndex.drawer + 100,
        color: "#fff",
      }}
      open={validatingUser}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingOverlay;
